// This file is generated by "pnpm json2ts"
export const CURRENT_SCHEMA_VERSION = '3.65.0';
export { default as anyProjectSchema } from './project-schema.json' with { type: 'json' };
export { default as latestSchemaJson } from './project-schema/v3.65.0.json' with { type: 'json' };
import experimentalSchemaJson from './project-schema/experimental-2025-07.json' with { type: 'json' };
import projectSchemaV1_0_0 from './project-schema/v1.0.0.json' with { type: 'json' };
import metaSchemaV1_0_0 from './project-schema/meta-schema-v1.0.0.json' with { type: 'json' };
import projectSchemaV3_0_0 from './project-schema/v3.0.0.json' with { type: 'json' };
import metaSchemaV3_0_0 from './project-schema/meta-schema-v3.0.0.json' with { type: 'json' };
import projectSchemaV3_1_0 from './project-schema/v3.1.0.json' with { type: 'json' };
import metaSchemaV3_1_0 from './project-schema/meta-schema-v3.1.0.json' with { type: 'json' };
import projectSchemaV3_2_0 from './project-schema/v3.2.0.json' with { type: 'json' };
import metaSchemaV3_2_0 from './project-schema/meta-schema-v3.2.0.json' with { type: 'json' };
import projectSchemaV3_3_0 from './project-schema/v3.3.0.json' with { type: 'json' };
import metaSchemaV3_3_0 from './project-schema/meta-schema-v3.3.0.json' with { type: 'json' };
import projectSchemaV3_4_0 from './project-schema/v3.4.0.json' with { type: 'json' };
import metaSchemaV3_4_0 from './project-schema/meta-schema-v3.4.0.json' with { type: 'json' };
import projectSchemaV3_5_0 from './project-schema/v3.5.0.json' with { type: 'json' };
import metaSchemaV3_5_0 from './project-schema/meta-schema-v3.5.0.json' with { type: 'json' };
import projectSchemaV3_5_1 from './project-schema/v3.5.1.json' with { type: 'json' };
import metaSchemaV3_5_1 from './project-schema/meta-schema-v3.5.1.json' with { type: 'json' };
import projectSchemaV3_6_0 from './project-schema/v3.6.0.json' with { type: 'json' };
import metaSchemaV3_6_0 from './project-schema/meta-schema-v3.6.0.json' with { type: 'json' };
import projectSchemaV3_7_0 from './project-schema/v3.7.0.json' with { type: 'json' };
import metaSchemaV3_7_0 from './project-schema/meta-schema-v3.7.0.json' with { type: 'json' };
import projectSchemaV3_8_0 from './project-schema/v3.8.0.json' with { type: 'json' };
import metaSchemaV3_8_0 from './project-schema/meta-schema-v3.8.0.json' with { type: 'json' };
import projectSchemaV3_9_0 from './project-schema/v3.9.0.json' with { type: 'json' };
import metaSchemaV3_9_0 from './project-schema/meta-schema-v3.9.0.json' with { type: 'json' };
import projectSchemaV3_10_0 from './project-schema/v3.10.0.json' with { type: 'json' };
import projectSchemaV3_11_0 from './project-schema/v3.11.0.json' with { type: 'json' };
import projectSchemaV3_12_0 from './project-schema/v3.12.0.json' with { type: 'json' };
import projectSchemaV3_12_1 from './project-schema/v3.12.1.json' with { type: 'json' };
import projectSchemaV3_12_2 from './project-schema/v3.12.2.json' with { type: 'json' };
import projectSchemaV3_12_3 from './project-schema/v3.12.3.json' with { type: 'json' };
import projectSchemaV3_13_0 from './project-schema/v3.13.0.json' with { type: 'json' };
import projectSchemaV3_14_0 from './project-schema/v3.14.0.json' with { type: 'json' };
import projectSchemaV3_15_0 from './project-schema/v3.15.0.json' with { type: 'json' };
import projectSchemaV3_16_0 from './project-schema/v3.16.0.json' with { type: 'json' };
import projectSchemaV3_17_0 from './project-schema/v3.17.0.json' with { type: 'json' };
import projectSchemaV3_17_1 from './project-schema/v3.17.1.json' with { type: 'json' };
import projectSchemaV3_18_0 from './project-schema/v3.18.0.json' with { type: 'json' };
import projectSchemaV3_18_1 from './project-schema/v3.18.1.json' with { type: 'json' };
import projectSchemaV3_18_2 from './project-schema/v3.18.2.json' with { type: 'json' };
import projectSchemaV3_19_0 from './project-schema/v3.19.0.json' with { type: 'json' };
import projectSchemaV3_20_0 from './project-schema/v3.20.0.json' with { type: 'json' };
import projectSchemaV3_21_0 from './project-schema/v3.21.0.json' with { type: 'json' };
import projectSchemaV3_22_0 from './project-schema/v3.22.0.json' with { type: 'json' };
import projectSchemaV3_23_0 from './project-schema/v3.23.0.json' with { type: 'json' };
import projectSchemaV3_24_0 from './project-schema/v3.24.0.json' with { type: 'json' };
import projectSchemaV3_25_0 from './project-schema/v3.25.0.json' with { type: 'json' };
import projectSchemaV3_26_0 from './project-schema/v3.26.0.json' with { type: 'json' };
import projectSchemaV3_27_0 from './project-schema/v3.27.0.json' with { type: 'json' };
import projectSchemaV3_28_0 from './project-schema/v3.28.0.json' with { type: 'json' };
import projectSchemaV3_29_0 from './project-schema/v3.29.0.json' with { type: 'json' };
import projectSchemaV3_30_0 from './project-schema/v3.30.0.json' with { type: 'json' };
import projectSchemaV3_31_0 from './project-schema/v3.31.0.json' with { type: 'json' };
import projectSchemaV3_32_0 from './project-schema/v3.32.0.json' with { type: 'json' };
import projectSchemaV3_33_0 from './project-schema/v3.33.0.json' with { type: 'json' };
import projectSchemaV3_34_0 from './project-schema/v3.34.0.json' with { type: 'json' };
import projectSchemaV3_35_0 from './project-schema/v3.35.0.json' with { type: 'json' };
import projectSchemaV3_36_0 from './project-schema/v3.36.0.json' with { type: 'json' };
import projectSchemaV3_37_0 from './project-schema/v3.37.0.json' with { type: 'json' };
import projectSchemaV3_38_0 from './project-schema/v3.38.0.json' with { type: 'json' };
import projectSchemaV3_39_0 from './project-schema/v3.39.0.json' with { type: 'json' };
import projectSchemaV3_40_0 from './project-schema/v3.40.0.json' with { type: 'json' };
import projectSchemaV3_41_0 from './project-schema/v3.41.0.json' with { type: 'json' };
import projectSchemaV3_42_0 from './project-schema/v3.42.0.json' with { type: 'json' };
import projectSchemaV3_43_0 from './project-schema/v3.43.0.json' with { type: 'json' };
import projectSchemaV3_44_0 from './project-schema/v3.44.0.json' with { type: 'json' };
import projectSchemaV3_45_0 from './project-schema/v3.45.0.json' with { type: 'json' };
import projectSchemaV3_46_0 from './project-schema/v3.46.0.json' with { type: 'json' };
import projectSchemaV3_47_0 from './project-schema/v3.47.0.json' with { type: 'json' };
import projectSchemaV3_48_0 from './project-schema/v3.48.0.json' with { type: 'json' };
import projectSchemaV3_49_0 from './project-schema/v3.49.0.json' with { type: 'json' };
import projectSchemaV3_50_0 from './project-schema/v3.50.0.json' with { type: 'json' };
import projectSchemaV3_51_0 from './project-schema/v3.51.0.json' with { type: 'json' };
import projectSchemaV3_52_0 from './project-schema/v3.52.0.json' with { type: 'json' };
import projectSchemaV3_53_0 from './project-schema/v3.53.0.json' with { type: 'json' };
import projectSchemaV3_54_0 from './project-schema/v3.54.0.json' with { type: 'json' };
import projectSchemaV3_55_0 from './project-schema/v3.55.0.json' with { type: 'json' };
import projectSchemaV3_56_0 from './project-schema/v3.56.0.json' with { type: 'json' };
import projectSchemaV3_57_0 from './project-schema/v3.57.0.json' with { type: 'json' };
import projectSchemaV3_58_0 from './project-schema/v3.58.0.json' with { type: 'json' };
import projectSchemaV3_59_0 from './project-schema/v3.59.0.json' with { type: 'json' };
import projectSchemaV3_60_0 from './project-schema/v3.60.0.json' with { type: 'json' };
import projectSchemaV3_61_0 from './project-schema/v3.61.0.json' with { type: 'json' };
import projectSchemaV3_62_0 from './project-schema/v3.62.0.json' with { type: 'json' };
import projectSchemaV3_63_0 from './project-schema/v3.63.0.json' with { type: 'json' };
import projectSchemaV3_64_0 from './project-schema/v3.64.0.json' with { type: 'json' };
import projectSchemaV3_65_0 from './project-schema/v3.65.0.json' with { type: 'json' };
import projectSchemaV4_0_0 from './project-schema/v4.0.0.json' with { type: 'json' };
export const allProjectSchemas = [
    experimentalSchemaJson,
    projectSchemaV1_0_0,
    metaSchemaV1_0_0,
    projectSchemaV3_0_0,
    metaSchemaV3_0_0,
    projectSchemaV3_1_0,
    metaSchemaV3_1_0,
    projectSchemaV3_2_0,
    metaSchemaV3_2_0,
    projectSchemaV3_3_0,
    metaSchemaV3_3_0,
    projectSchemaV3_4_0,
    metaSchemaV3_4_0,
    projectSchemaV3_5_0,
    metaSchemaV3_5_0,
    projectSchemaV3_5_1,
    metaSchemaV3_5_1,
    projectSchemaV3_6_0,
    metaSchemaV3_6_0,
    projectSchemaV3_7_0,
    metaSchemaV3_7_0,
    projectSchemaV3_8_0,
    metaSchemaV3_8_0,
    projectSchemaV3_9_0,
    metaSchemaV3_9_0,
    projectSchemaV3_10_0,
    projectSchemaV3_11_0,
    projectSchemaV3_12_0,
    projectSchemaV3_12_1,
    projectSchemaV3_12_2,
    projectSchemaV3_12_3,
    projectSchemaV3_13_0,
    projectSchemaV3_14_0,
    projectSchemaV3_15_0,
    projectSchemaV3_16_0,
    projectSchemaV3_17_0,
    projectSchemaV3_17_1,
    projectSchemaV3_18_0,
    projectSchemaV3_18_1,
    projectSchemaV3_18_2,
    projectSchemaV3_19_0,
    projectSchemaV3_20_0,
    projectSchemaV3_21_0,
    projectSchemaV3_22_0,
    projectSchemaV3_23_0,
    projectSchemaV3_24_0,
    projectSchemaV3_25_0,
    projectSchemaV3_26_0,
    projectSchemaV3_27_0,
    projectSchemaV3_28_0,
    projectSchemaV3_29_0,
    projectSchemaV3_30_0,
    projectSchemaV3_31_0,
    projectSchemaV3_32_0,
    projectSchemaV3_33_0,
    projectSchemaV3_34_0,
    projectSchemaV3_35_0,
    projectSchemaV3_36_0,
    projectSchemaV3_37_0,
    projectSchemaV3_38_0,
    projectSchemaV3_39_0,
    projectSchemaV3_40_0,
    projectSchemaV3_41_0,
    projectSchemaV3_42_0,
    projectSchemaV3_43_0,
    projectSchemaV3_44_0,
    projectSchemaV3_45_0,
    projectSchemaV3_46_0,
    projectSchemaV3_47_0,
    projectSchemaV3_48_0,
    projectSchemaV3_49_0,
    projectSchemaV3_50_0,
    projectSchemaV3_51_0,
    projectSchemaV3_52_0,
    projectSchemaV3_53_0,
    projectSchemaV3_54_0,
    projectSchemaV3_55_0,
    projectSchemaV3_56_0,
    projectSchemaV3_57_0,
    projectSchemaV3_58_0,
    projectSchemaV3_59_0,
    projectSchemaV3_60_0,
    projectSchemaV3_61_0,
    projectSchemaV3_62_0,
    projectSchemaV3_63_0,
    projectSchemaV3_64_0,
    projectSchemaV3_65_0,
    projectSchemaV4_0_0
];
